import React from "react";
import AuthLayout from "./AuthLayout";
import MarketingFooter from "./MarketingFooter";
import { SessionField, SubmitButton } from "./AuthFields";

const LoginPage = ({ action, showForgotLink, forgotPasswordPath }) => (
  <AuthLayout
    action={action}
    formClassName="login-form"
    autoComplete="off"
    formInnerStyle={{ marginTop: "30px" }}
    footer={<MarketingFooter />}
  >
    <SessionField type="text" name="user[email]" id="user_email" placeholder="Email" autoFocus />
    <SessionField type="password" name="user[password]" id="user_password" placeholder="Password" />
    <div className="mtm">
      <SubmitButton value="LOG-IN" />
      {showForgotLink && (
        <a href={forgotPasswordPath} className="option-link btn-session forgot-password-link">
          Forgot password?
        </a>
      )}
    </div>
  </AuthLayout>
);

export default LoginPage;
